<template>
  <div class="table" v-loading="tableLoading">
    <el-table :data="data" width="100%">
      <el-table-column
        label="#"
        prop="id"
        width="80"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="name"
        label="Employee Name"
        width="200"
        :formatter="tableFormatter"
      >
      </el-table-column>
      <el-table-column
        prop="clock_date"
        label="date"
        width="200"
        :formatter="dateTableFormatter"
      >
      </el-table-column>
      <el-table-column
        prop="clock_type"
        label="Clock Type"
        width="200"
        :formatter="tableFormatter"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.clock_type === 'clock_in'">Clock In</div>
          <div v-if="scope.row.clock_type === 'clock_out'">Clock Out</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="clock_time"
        label="Time"
        width="200"
        :formatter="tableFormatter"
      >
      </el-table-column>
      <el-table-column
        prop="clock_address"
        label="LOCATION"
        width="250"
        :formatter="tableFormatter"
      >
      </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        mini
        @size-change="handleSizeChangeForLogs"
        @current-change="handleCurrentChangeForLogs"
        :current-page.sync="currentPage"
        :page-sizes="pageSizes"
        :page-size="perPageForLogs"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalLogs"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { tableFormatter, dateTableFormatter } from "@/helpers/functions";
import { createNamespacedHelpers } from "vuex";
const { mapState, mapActions } = createNamespacedHelpers(
  "ess/attendance/mobileClocks"
);
export default {
  props: ["data"],
  data() {
    return {
      pageSizes: this.$store.state.admin.pageSizes,
    };
  },
  computed: {
    ...mapState(["perPageForLogs", "totalLogs", "tableLoading"]),
    currentPage: {
      get() {
        return this.$store.state.admin.attendance.mobileClocks
          .currentPageForLogs;
      },
      set(value) {
        this.$store.commit(
          "admin/attendance/mobileClocks/currentPageForLogs",
          value
        );
      },
    },
  },
  methods: {
    tableFormatter,
    dateTableFormatter,
    ...mapActions(["handleSizeChangeForLogs", "handleCurrentChangeForLogs"]),
  },
};
</script>

<style lang="css">
.drop-down-link {
  text-decoration: none;
  color: #606266;
}
.grey {
  background-color: #abb3bf;
  color: #091540;
}
</style>
